export const SUPER_ADMIN: string = "SUPER_ADMIN";
export const ACCOUNTANT_ADMIN: string = "ACCOUNTANT_ADMIN";
export const USER: string = "USER";
export const USER_INDEPENDENT: string = "USER_INDEPENDENT";
